import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown, MapPinned } from "lucide-react";
import { MAP_LINKS } from "../../data/maps";

export const MapsMenu = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (e.key === "Escape" || (ref.current && !ref.current.contains(e.target))) setOpen(false); };
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", close);
    return () => { document.removeEventListener("mousedown", close); document.removeEventListener("keydown", close); };
  }, [open]);
  return (
    <div ref={ref} className="relative">
      <button type="button" data-testid="hero-maps-cta" aria-expanded={open} onClick={() => setOpen((v) => !v)}
        className="w-full inline-flex items-center justify-center gap-2 whitespace-nowrap border border-gf-primary/50 text-gf-primary font-body font-bold text-base px-7 py-4 hover:bg-gf-primary/10 transition-colors duration-200">
        <MapPinned className="w-4 h-4" /> Infra & Intel Maps
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div data-testid="hero-maps-dropdown" initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 8 }} transition={{ duration: 0.18 }}
            className="absolute left-0 sm:left-auto sm:right-0 bottom-full mb-3 w-[320px] z-30">
            <div className="bg-gf-surface border border-white/10 shadow-2xl p-2">
              {MAP_LINKS.map((m) => (
                <Link key={m.key} to={m.to} data-testid={`hero-map-${m.key}`} onClick={() => setOpen(false)}
                  className={`block px-3 py-2.5 hover:bg-white/[0.04] transition-colors ${m.highlight ? "border-l-2 border-gf-primary" : ""}`}>
                  <p className={`font-body text-sm ${m.highlight ? "text-gf-primary font-bold" : "text-gf-text/90"}`}>{m.label}</p>
                  <p className="font-mono text-[10px] text-gf-muted mt-0.5">{m.sub}</p>
                </Link>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
